module.exports = __webpack_public_path__ + "img/8.d62bc86b.png";